module.exports = __webpack_public_path__ + "static/img/004.7ea06f21.png";